import React from "react";
import { FormattedMessage } from "react-intl";

import TableHeader from "../../app/generic/tableHeader";
import TooltipButton from "../../app/generic/tooltipButton";

export default function Header({ onNewLoginClick }) {
  return (
    <TableHeader
      equal
      title={
        <FormattedMessage
          id="oneTimeLogin.list"
          defaultMessage="Jednorázové přihlášení"
        />
      }
      right={
        <TooltipButton
          icon="plus"
          onClick={onNewLoginClick}
          title={
            <FormattedMessage
              id="oneTimeLogin.new.title"
              defaultMessage="Vytvoření nového jednorázového přihlášení"
            />
          }
          text={
            <FormattedMessage
              id="oneTimeLogin.new"
              defaultMessage="Nové přihlášení"
            />
          }
        />
      }
    />
  );
}
